import {Component, OnInit, inject} from '@angular/core';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MenuSuperiorTemplateComponent} from '../utils/menu-superior-template/menu-superior-template.component';
import {EscolhaCanalTemplateComponent} from '../utils/escolha-canal-template/escolha-canal-template.component';
import {InteracaoMarketingComponent} from '../utils/interacao-marketing/interacao-marketing.component';
import {CanalTemplateEnum} from '../../shared/enum/canal-template.enum';
import {TemplateModel} from '../../shared/model/template/template-model';
import {TemplateSalvamentoModel} from '../../shared/model/template/template-salvamento-model';
import {MsgService} from '../../shared/service/msg.service';
import {TemplateMensagemService} from '../../shared/service/template-mensagem.service';
import {ModalConfirmacaoComponent} from '../../shared/modais/modal-confirmacao/modal-confirmacao.component';
import {Perfil} from '../../shared/model/perfil/perfil.model';
import {extrairMensagemErro} from '../../shared/util/http-error.util';

@Component({
  selector: 'app-modal-cadastro-visualizacao-template',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    MenuSuperiorTemplateComponent,
    EscolhaCanalTemplateComponent,
    InteracaoMarketingComponent,
  ],
  templateUrl: './modal-cadastro-visualizacao-template.component.html',
  styleUrl: './modal-cadastro-visualizacao-template.component.css'
})
export class ModalCadastroVisualizacaoTemplateComponent implements OnInit {

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoTemplateComponent>);
  private readonly matDialog = inject(MatDialog);
  public readonly data = inject(MAT_DIALOG_DATA);
  private readonly msgService = inject(MsgService);
  private readonly templateService = inject(TemplateMensagemService);

  visualizar = false;
  edicao = false;
  salvando = false;
  template: TemplateModel = new TemplateModel();

  ngOnInit() {
    this.visualizar = this.data['visualizar'];
    this.edicao = this.data['edicao'];
    this.template = this.data['template'];
    if(this.template){
      this.buscarArquivoHeaderTemplate();
    }

    this.template.tipo = this.ehSms() ? CanalTemplateEnum.SMS : CanalTemplateEnum.WHATSAPP;

    if(this.ehSms()){
      this.template.categoria = undefined;
    }
    else if(this.template.categoria){
      this.receberOpcaoSeleciodaMenu(this.template.categoria);
    }
    else{
      this.template.categoria = 'MARKETING';
    }
  }

  ehSms(): boolean {
    return (this.template.tipo || '').toUpperCase() === CanalTemplateEnum.SMS;
  }

  receberCanal(canal: string){
    this.template.tipo = canal;
    if(this.ehSms()){
      this.template.categoria = undefined;
    }
    else if(!this.template.categoria){
      this.template.categoria = 'MARKETING';
    }
  }

  buscarArquivoHeaderTemplate(){
    if(this.template.id){
      this.templateService.buscarArquivoHeaderTemplate(this.template.id).subscribe({
        next: data => {
          this.template.templateCabecalho.blob = URL.createObjectURL(data);
        }
      });
    }
  }

  receberOpcaoSeleciodaMenu(opcao: string){
    this.template.categoria = opcao;
  }

  salvar() {
    if(this.validarInformacoes()){
      this.matDialog.open(ModalConfirmacaoComponent, {
        height: '200px',
        data: { texto: this.ehSms() ? 'Deseja salvar o template SMS?' : 'Irá enviar o template para a Meta, deseja salvar?' }
      }).afterClosed().subscribe({
        next: (res: Perfil) => {
          if (res) {
            this.salvarTemplate();
          }
        }
      });
    }
  }

  private salvarTemplate() {
    delete this.template.templateCabecalho.blob;
    const obj = new TemplateSalvamentoModel().converterParaEnvio(this.template);

    this.salvando = true;
    this.templateService.salvarTemplate(obj).subscribe({
      next: () => {
        this.msgService.msgSucesso('Template salvo com sucesso!');
        this.salvando = false;
        this.dialog.close(true);
      },
      error: err => {
        this.salvando = false;
        this.msgService.msgErro(extrairMensagemErro(err, 'Não foi possível salvar o template.'));
      }
    });
  }

  cancelar() {
    this.dialog.close();
  }

  validarInformacoes(): boolean {
    if(!this.template.nome || this.template.nome === ''){
      this.msgService.msgAdvertencia('Informe um titulo para o template');
      return false;
    }

    if(this.ehSms()){
      if(!this.template.variavel.corpo || this.template.variavel.corpo === ''){
        this.msgService.msgAdvertencia('Informe um corpo para o template');
        return false;
      }
      return true;
    }

    if(!this.template.idioma){
      this.msgService.msgAdvertencia('Selecione um idioma para o template');
      return false;
    }
    else if(!this.template.variavel.corpo || this.template.variavel.corpo === ''){
      this.msgService.msgAdvertencia('Informe um corpo para o template');
      return false;
    }
    else if(!this.template.conta || !this.template.conta.id){
      this.msgService.msgAdvertencia('Selecione um número para o template');
      return false;
    }
    else if(this.template.variavelFixa && this.template.variavel.variaveis.some(v => !v.tipoCampoFixo)){
      this.msgService.msgAdvertencia('Em um template de variável fixa, selecione a origem de todas as variáveis.');
      return false;
    }
    return true;
  }

  protected readonly console = console;
}
